const currentYear: number = new Date().getFullYear();

// Provides the minimum length a text filter must be to be used.
// It needs to be at least 3 due to trigrams used in Elasticsearch.
export const minFilterLength = 3;

// Months in Numbers.
export const months = [
  { value: '', label: 'MM' },
  { value: '01', label: '01' },
  { value: '02', label: '02' },
  { value: '03', label: '03' },
  { value: '04', label: '04' },
  { value: '05', label: '05' },
  { value: '06', label: '06' },
  { value: '07', label: '07' },
  { value: '08', label: '08' },
  { value: '09', label: '09' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
];

// CurrentYear till CurrentYear + 20 (used in payments).
const firstItem = { value: '', label: 'YYYY' };

// FIXME: Add function return type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getFutureYears = (year = currentYear, count = 20) => [
  firstItem,
  ...new Array(count).fill(null).map((item, index) => {
    const newYear = year + index;
    return { label: newYear, value: newYear };
  }),
];

export const futureYears = getFutureYears();

// Date Ranges.
export const dateRanges = [
  { value: '7', label: 'Last 7 days' },
  { value: '15', label: 'Last 15 days' },
  { value: '30', label: 'Last 30 days' },
  { value: '90', label: 'Last 90 days' },
  { value: '180', label: 'Last 180 days' },
  { value: '365', label: 'Last 12 months' },
];

// Items to show per page in tables.
export const itemsPerPage = 50;

export const itemsPerPageChoices = [
  { value: 30, label: '30' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
];

// Incoming feedback sentiment style choices.
export const incomingEmotionStyleChoices = [
  { value: 'default', labelKey: 'buddies', feature: false },
  { value: 'emoji', labelKey: 'emojis', feature: 'feedback.emotion_style_choices' },
  { value: 'smiley', labelKey: 'smileys', feature: 'feedback.emotion_style_choices' },
  { value: 'star', labelKey: 'stars', feature: 'feedback.emotion_style_choices' },
];

// Widget skin choices.
export const skinChoices = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

// Show/Hide choices.
export const visibilityChoices = [
  { value: true, label: 'Show' },
  { value: false, label: 'Hide' },
];

// Recording snapshot sizes.
export const recordingSnapshots = [
  { value: 100, label: 100 },
  { value: 2000, label: 2000 },
  { value: 5000, label: 5000 },
];

// Forms snapshot sizes.
export const formSnapshots = [
  { value: 1000, label: 1000 },
  { value: 2000, label: 2000 },
  { value: 5000, label: 5000 },
];

// Heatmap snapshot sizes.
export const heatmapSnapshots = [
  { value: 1000, label: 1000 },
  { value: 2000, label: 2000 },
  { value: 10000, label: 10000 },
];

export const defaultAlwaysOnRate = 0;

// Payment Method choices.
export const paymentMethodChoices = [
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'paypal', label: 'PayPal' },
];

// Email for Hotjar support account.
export const supportAccountEmail = 'support@hotjar.com';

export const organizationSizeChoices = [
  { value: '1-10', label: '1 - 10 employees' },
  { value: '11-50', label: '11 - 50 employees' },
  { value: '51-100', label: '51 - 100 employees' },
  { value: '101-250', label: '101 - 250 employees' },
  { value: '251-1000', label: '251 - 1k employees' },
  { value: '1000-5000', label: '1K - 5K employees' },
  { value: '5000+', label: '5K+ employees' },
];

// RTL languages.
export const rtlLanguages = ['ar', 'fa', 'he'];

// Attribute match operations for the different types.
// View can be any of the following:
//
// 1) string / email: Shows an input field of type "text".
// 2) number: Shows an input field of type "number".
// 3) number_and_label: Shows an input field of type "number" with a label next to it.
// 4) date_picker: Shows a date picker.
// 5) null: Shows no input method for the pattern.
export const stringOperations = [
  { match_operation: 'exact', label: 'is', view: 'text' },
  { match_operation: 'exact_negate', label: 'is not', view: 'text' },
  { match_operation: 'contains', label: 'contains', view: 'text' },
  { match_operation: 'contains_negate', label: 'does not contain', view: 'text' },
  { match_operation: 'starts_with', label: 'starts with', view: 'text' },
  { match_operation: 'ends_with', label: 'ends with', view: 'text' },
  { match_operation: 'unknown', label: 'is unknown', view: null },
  { match_operation: 'unknown_negate', label: 'has any value', view: null },
];

export const attributeTypeMatchOperationChoices = {
  boolean: [
    { match_operation: 'exact', label: 'is true', view: null },
    { match_operation: 'exact_negate', label: 'is false', view: null },
    { match_operation: 'unknown', label: 'is unknown', view: null },
    { match_operation: 'unknown_negate', label: 'has any value', view: null },
  ],
  date: [
    { match_operation: 'more_than_days_ago', label: 'more than', view: 'number_and_label' },
    { match_operation: 'exact_days_ago', label: 'exactly', view: 'number_and_label' },
    { match_operation: 'less_than_days_ago', label: 'less than', view: 'number_and_label' },
    { match_operation: 'greater_than', label: 'after', view: 'date_picker' },
    { match_operation: 'exact_date', label: 'on', view: 'date_picker' },
    { match_operation: 'less_than', label: 'before', view: 'date_picker' },
    { match_operation: 'unknown', label: 'is unknown', view: null },
    { match_operation: 'unknown_negate', label: 'has any value', view: null },
  ],
  email: stringOperations,
  number: [
    { match_operation: 'greater_than', label: 'greater than', view: 'number' },
    { match_operation: 'less_than', label: 'less than', view: 'number' },
    { match_operation: 'exact', label: 'is', view: 'number' },
    { match_operation: 'exact_negate', label: 'is not', view: 'number' },
    { match_operation: 'unknown', label: 'is unknown', view: null },
    { match_operation: 'unknown_negate', label: 'has any value', view: null },
  ],
  string: stringOperations,
};

// Bank Transfer details when paying via wire-transfers to Hotjar.
export const bankTransferDetails = {
  eur: {
    accountHolder: 'Hotjar Ltd.',
    bank: 'HSBC',
    iban: 'MT61MMEB44093000000009115270001',
    swift: 'MMEBMTMT',
  },
  usd: {
    accountHolder: 'Hotjar Ltd.',
    bank: 'HSBC',
    iban: 'MT36MMEB44093000000009115270451',
    swift: 'MMEBMTMT',
  },
};

export const customEvents = {
  recordings: {
    EVENT_FILTER_SELECTED: 'filters.eventFilterSelected',
    FIRST_SEGMENT_SAVED: 'segments.firstOneSaved',
    FIRST_FILTER_ADDED: 'filters.firstOneAdded',
    TAG_FILTER_SELECTED: 'filters.tagFilterSelected',
    EXPERIMENTS_FILTER_SELECTED: 'filters.experimentsFilterSelected',
  },
  ui: {
    SHOW_TOOLTIP: 'showTooltip',
    HIDE_TOOLTIP: 'hideTooltip',
  },
};

export const DESKTOP_DEVICE_TYPE = 'desktop';

export const TABLET_DEVICE_TYPE = 'tablet';

export const PHONE_DEVICE_TYPE = 'phone';

export const deviceTypesInOrder = [DESKTOP_DEVICE_TYPE, TABLET_DEVICE_TYPE, PHONE_DEVICE_TYPE];

export const deviceDimensions = {
  [DESKTOP_DEVICE_TYPE]: 1280,
  [TABLET_DEVICE_TYPE]: 800,
  [PHONE_DEVICE_TYPE]: 380,
};

// Language options.
export const languageChoices = [
  { value: 'af', native_label: 'Afrikaans', label: 'Afrikaans' },
  { value: 'ar', native_label: 'العربية', label: 'Arabic' },
  { value: 'bg', native_label: 'Български', label: 'Bulgarian' },
  { value: 'ca', native_label: 'Català', label: 'Catalan' },
  { value: 'cs', native_label: 'Čeština', label: 'Czech' },
  { value: 'cy', native_label: 'Cymraeg', label: 'Welsh' },
  { value: 'da', native_label: 'Dansk', label: 'Danish' },
  { value: 'de', native_label: 'Deutsch', label: 'German' },
  { value: 'el', native_label: 'ελληνικά', label: 'Greek' },
  { value: 'en', native_label: 'English', label: 'English' },
  { value: 'es', native_label: 'Español', label: 'Spanish' },
  { value: 'et', native_label: 'Eesti', label: 'Estonian' },
  { value: 'fa', native_label: 'فارسی', label: 'Farsi' },
  { value: 'fi', native_label: 'Suomi', label: 'Finnish' },
  { value: 'fr', native_label: 'Français', label: 'French' },
  { value: 'he', native_label: 'עברית', label: 'Hebrew' },
  { value: 'hr', native_label: 'Hrvatski', label: 'Croatian' },
  { value: 'hu', native_label: 'Magyar', label: 'Hungarian' },
  { value: 'id', native_label: 'Bahasa Indonesia', label: 'Indonesian' },
  { value: 'it', native_label: 'Italiano', label: 'Italian' },
  { value: 'ja', native_label: '日本語', label: 'Japanese' },
  { value: 'ko', native_label: '한국어', label: 'Korean' },
  { value: 'lt', native_label: 'Lietuvių', label: 'Lithuanian' },
  { value: 'lv', native_label: 'Latviešu', label: 'Latvian' },
  { value: 'mis', native_label: 'Crnogorski', label: 'Montenegrin' },
  { value: 'nb', native_label: 'Norsk bokmål', label: 'Norwegian (Bokmål)' },
  { value: 'nl', native_label: 'Nederlands', label: 'Dutch' },
  { value: 'pl', native_label: 'Polski', label: 'Polish' },
  { value: 'pt', native_label: 'Português', label: 'Portuguese' },
  { value: 'pt_BR', native_label: 'Português Brasileiro', label: 'Portuguese (Brazilian)' },
  { value: 'ro', native_label: 'Română', label: 'Romanian' },
  { value: 'ru', native_label: 'Русский', label: 'Russian' },
  { value: 'sk', native_label: 'Slovenčina', label: 'Slovak' },
  { value: 'sl', native_label: 'Slovenščina', label: 'Slovenian' },
  { value: 'sq', native_label: 'Shqip', label: 'Albanian' },
  { value: 'sr', native_label: 'Srpski', label: 'Serbian' },
  { value: 'sv', native_label: 'Svenska', label: 'Swedish' },
  { value: 'sw', native_label: 'Kiswahili', label: 'Swahili' },
  { value: 'th', native_label: 'ไทย', label: 'Thai' },
  { value: 'tl', native_label: 'Tagalog', label: 'Filipino' },
  { value: 'tr', native_label: 'Türkçe', label: 'Turkish' },
  { value: 'uk', native_label: 'Українська', label: 'Ukrainian' },
  { value: 'vi', native_label: 'Tiếng Việt', label: 'Vietnamese' },
  { value: 'zh_CN', native_label: '中文', label: 'Chinese (Simplified)' },
  { value: 'zh_TW', native_label: '繁體中文', label: 'Chinese (Traditional)' },
].sort((a, b) => a.label.localeCompare(b.label)); // Sort languages by their English labels.

// Incoming Feedback language options.
// Montenigrin (mis) translations not available for Incoming Feedback.
export const incomingFeedbackLanguageChoices = languageChoices.filter(
  (lang) => lang.value !== 'mis',
);

export const CUSTOM_EVENTS = customEvents;
